import {createApp } from 'vue'
import GoogleMapAC from '../GoogleMapAC.vue'
import i18n from "../../../i18n";
import GoogleMapsHelper from "../../../../../vendor/xkit/google-maps/google-maps-helper.js";

let $ = jQuery

// let loaded_ga = false
// $('body').on('google-maps-loaded', function(){
// 	init_ga()
// })
// if ( window.loaded_ga ) {
// 	init_ga()
// }

GoogleMapsHelper.bootstrap_api()

async function init_gmaps_ac(){
	// if ( loaded_ga ) {
	// 	return
	// }
	// loaded_ga = true
	if ( $( '.google-maps-autocomplete' ).length ) {
		$( '.google-maps-autocomplete' ).each( function () { //:not([data-v-app])
			let appGA = createApp( GoogleMapAC, { wrapper_id : this.id, data: JSON.parse( this.dataset.state ) } )
			appGA.config.devtools = true;

			// app.use(pinia)
			appGA.use( i18n )
			appGA.mount( this )

		} )
	}
}
export default init_gmaps_ac